module.exports = __webpack_public_path__ + "static/img/cert-bg.044ccb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert/cert-bg.png
// module id = /4qb
// module chunks = 126